<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-footer app inset padless absolute>
      <v-col class="text-center">
        {{ new Date().getFullYear() }} — <strong>© SIGN8 GmbH</strong> |
        <hyper-link
          target="_blank"
          :link="$t('Sign8Links.privacy_policy')"
          :text="$t('BottomFooter.imprint')"
        ></hyper-link>
        |
        <hyper-link
          target="_blank"
          :link="$t('Sign8Links.terms_of_use')"
          :text="$t('BottomFooter.gdpr')"
        ></hyper-link>
      </v-col>
    </v-footer>
  </v-container>
</template>


<script>
import i18n from '../../i18n';
import HyperLink from "../ui/text/HyperLink";

export default {
  name: "bottom-footer",
  components: {
    HyperLink,
  },
  created() {

    this.mobile = this.$vuetify.breakpoint.mdAndDown;
  },
  data() {
    return {
      mobile: false,
    };
  },
};
</script>
